import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconGeoObjHorizon2DS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1 8.69928L1 6.37487C1.04676 6.31733 1.09526 6.25962 1.14555 6.2019C2.1092 5.09568 3.71843 4 6.24998 4C8.74685 4 11.2278 5.13858 13.0411 6.22736C13.8186 6.69422 14.4874 7.1606 15 7.54288V9C14.8769 8.89944 14.7213 8.77521 14.5368 8.6336C14.0266 8.24187 13.2988 7.71948 12.4299 7.19776C10.6743 6.14358 8.41979 5.1392 6.24998 5.1392C4.11487 5.1392 2.81399 6.04487 2.03421 6.94001C1.63913 7.39353 1.37521 7.84856 1.21063 8.18965C1.12861 8.35963 1.07209 8.49961 1.03683 8.59454C1.01957 8.64101 1.00746 8.67652 1 8.69928Z"
        fill="currentcolor"
      />
      <path
        d="M1 11.6993L1 9.37487C1.04676 9.31733 1.09526 9.25962 1.14555 9.2019C2.1092 8.09568 3.71843 7 6.24998 7C8.74685 7 11.2278 8.13858 13.0411 9.22736C13.8186 9.69422 14.4874 10.1606 15 10.5429V12C14.8769 11.8994 14.7213 11.7752 14.5368 11.6336C14.0266 11.2419 13.2988 10.7195 12.4299 10.1978C10.6743 9.14358 8.41979 8.1392 6.24998 8.1392C4.11487 8.1392 2.81399 9.04487 2.03421 9.94001C1.63913 10.3935 1.37521 10.8486 1.21063 11.1897C1.12861 11.3596 1.07209 11.4996 1.03683 11.5945C1.01957 11.641 1.00746 11.6765 1 11.6993Z"
        fill="currentcolor"
      />
    </svg>
  )
}

export const IconGeoObjHorizon2D = createIcon({
  l: IconGeoObjHorizon2DS,
  m: IconGeoObjHorizon2DS,
  s: IconGeoObjHorizon2DS,
  xs: IconGeoObjHorizon2DS,
  name: 'IconGeoObjHorizon2D',
})
